export const environment = {
    production: true,
    apiUrl: 'https://agenzie.pataviumenergia.it/patavium-console-rest-api/api',
    socketUrl: 'https://agenzie.pataviumenergia.it',
    websocket_session_url: 'https://agenzie.pataviumenergia.it',
    application_name: 'patavium-console-ui'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts